"use strict";
var $dyn;
(function ($dyn) {
    /**
     * Fills in placeholders in template with content.
     * @param targetElement The template instance to fill in the placeholders for.
     * @param content The content used to fill in the placeholders
     * @returns The transformed target element.
     */
    function applyContent(targetElement, content) {
        // Template usage:
        // <div data-dyn-templateId="myTemplate">
        //    <div class="all">My content</div>
        // </div>
        //
        // Template html:
        // <div id="myTemplate">
        //    <div data-dyn-content="replace: '.all'" /> <!-- Would replace <div data-dyn-content="replace: '.all'" /> with
        //    <div data-dyn-content="replace: $content" />
        // </div>
        if (!targetElement) {
            return;
        }
        var binding;
        var evaluator = $dyn._parseContent(targetElement[0]);
        var contentWrapper = $dyn._isContentWrapper(content) ? content : $dyn._createContentWrapper(content);
        var children = targetElement.children();
        if (evaluator) {
            binding = evaluator(contentWrapper);
        }
        if (binding) {
            // tslint:disable-next-line:forin
            for (var bindingType in binding) {
                var bindingData = binding[bindingType];
                // Get the handler
                var handlersAnyType = $dyn.contentHandlers;
                var handler = handlersAnyType[bindingType];
                // apply the data through the handler
                if (handler) {
                    handler(targetElement, bindingData, contentWrapper);
                }
            }
        }
        // Reversed foreach. If an non-cloned element is used multiple times then it is expected than the first reference will be the final location of the element
        // TODO: Ideally we should be doing iteration on a flat list not recursion.  If when the content elements are parsed, we should keep a flat list.
        for (var i = children.length - 1; i >= 0; --i) {
            // Current data context propagates to descendants
            $dyn.applyContent($(children[i]), contentWrapper);
        }
        return targetElement;
    }
    $dyn.applyContent = applyContent;
    /**
     * Calls contentChanged method when the content for a targetElement is updated.
     * @param targetElement Target element whose content has been updated
     */
    function updateContent(targetElement) {
        if (targetElement) {
            var content = targetElement.dynContent;
            if (content && content.contentChanged) {
                content.contentChanged();
            }
            var children_1 = targetElement.children;
            for (var i = children_1.length - 1; i >= 0; --i) {
                $dyn.updateContent(children_1[i]);
            }
        }
    }
    $dyn.updateContent = updateContent;
    /**
     * Creates an evaluator function by parsing a content expression.
     * @description The evaluator takes current contentWrapper as parameter.
     */
    function _parseContentExpression(bindingExpression) {
        // If the expression contains a ':' without any single, double quote and { preceding it, we will
        // need to add '{' and '}' around the expression to objectify the open expressions
        if (bindingExpression.match("^[^\\{]+\\:")) {
            bindingExpression = "{" + bindingExpression + "}";
        }
        // Create the expression as a function
        return new Function("contentWrapper", "var scope = { $content:  $dyn.value(contentWrapper.current), $parent: contentWrapper.parent };" +
            "if (contentWrapper.scopeVars) { $.extend(scope, contentWrapper.scopeVars); }" +
            "with(scope) {" +
            "return (" + bindingExpression + ");" +
            "}");
    }
    $dyn._parseContentExpression = _parseContentExpression;
    /**
     * Parses and gets the content evaluator associated with the node.
     * @description Parses and gets the content evaluator associated with the node as a function that can be executed by passing in
     * parent content. If no data-dyn-content attribute exists, this returns null. This method caches the parsed content
     * evaluator as an invocable function on the element's data.
     */
    // tslint:disable-next-line:ban-types
    function _parseContent(targetElement) {
        var evaluator;
        // var evaluator = $.data(targetElement, 'dyn-content-eval');
        // Check if we have an expression already parsed
        // if (evaluator === undefined) {
        var dataContentAttr = $(targetElement).attr("data-dyn-content");
        if (dataContentAttr) {
            // Create the eval-able expression from the binding expression
            evaluator = $dyn._parseContentExpression(dataContentAttr);
        }
        else {
            evaluator = null;
        }
        // Cache the evaluator
        // $.data(targetElement, 'dyn-content-eval', evaluator);
        // }
        return evaluator;
    }
    $dyn._parseContent = _parseContent;
    /**
     * Creates a content wrapper given a new object to be used as the $content, and an optional parent content wrapper.
     */
    function _createContentWrapper(objectAsCurrent, parentWrapper, scopeVars) {
        return {
            __isContentWrapper: true,
            // Gets the current content.
            current: (objectAsCurrent === undefined) ? null : objectAsCurrent,
            parent: function (offset) {
                if (parentWrapper === null) {
                    return null;
                }
                else if (offset === undefined || offset === 0) {
                    return parentWrapper.current;
                }
                else {
                    return parentWrapper.parent(offset - 1);
                }
            },
            scopeVars: scopeVars,
        };
    }
    $dyn._createContentWrapper = _createContentWrapper;
    /**
     * Checks if an object is a content wrapper or not.
     */
    function _isContentWrapper(object) {
        return (object !== null) && (object !== undefined) && (object.__isContentWrapper === true);
    }
    $dyn._isContentWrapper = _isContentWrapper;
    /**
     * Helper method for content handlers to evaluate the content.
     * @param bindingValue If it is jQuery, then it is an object containing the content that
     *              should replace the target. If it is a string, then it is representing a jQuery selector to be used
     *              to filter the jQuery content. If it is an object, then it has the following properties:
     *              contents and clone, which is a flag to indicate if the content should be cloned.
     * @param content The jQuery object containing the content in the current scope.
     * @returns See the bindingValue param object form.
     */
    function getContentOptions(bindingValue, content) {
        // TODO TFS:3745038 Should probably not be on $dyn
        var current;
        if ($.isPlainObject(bindingValue)) {
            var bindingValueAsObj = bindingValue;
            if (typeof (bindingValueAsObj.content) === "string") {
                current = $dyn.value(content.current);
                if (current) {
                    bindingValueAsObj.content = bindingValueAsObj.content === "*" ? current : $dyn.util.filter(current, bindingValueAsObj.content);
                    bindingValueAsObj.name = bindingValueAsObj.content;
                }
                else {
                    bindingValueAsObj.content = $();
                }
            }
            else if (typeof (bindingValueAsObj.find) === "string") {
                current = $dyn.value(content.current);
                if (current) {
                    bindingValueAsObj.content = current.find(bindingValueAsObj.find);
                    bindingValueAsObj.name = "find " + bindingValueAsObj.find;
                }
                else {
                    bindingValueAsObj.content = $();
                }
            }
            return bindingValueAsObj;
        }
        else if (typeof (bindingValue) === "string") {
            current = $dyn.value(content.current);
            if (current) {
                return { name: bindingValue, content: bindingValue === "*" ? current : $dyn.util.filter(current, bindingValue), clone: false };
            }
            else {
                return { content: $(), clone: false };
            }
        }
        else {
            // $context type of scenario.  Should need to unwrap a value in order to set up a dependency on it.
            return { content: bindingValue, clone: false };
        }
    }
    $dyn.getContentOptions = getContentOptions;
    /** Content handlers represent the method of filling placeholders in a template */
    var contentHandlers;
    (function (contentHandlers) {
        /**
         * Replaces the target element with the evaluated contents.
         * @deprecated
         * @param target The jQuery object containing the target element.
         * @param bindingValue 1. A jQuery object containing the content that should replace the target.
         *                     2. A string representing a jQuery selector to be used to filter the jQuery content.
         *                     3. An object containing the contents and a flag to indicate if the content should be cloned.  Example, { content: '.exampleCssClass', clone: true }
         * @param content The jQuery object containing the content in the current scope.
         * @remarks Temlate usage:
         * <div data-dyn-templateId="myTemplate">
         *    <div class="all">My content</div>
         * </div>
         *
         * Template html:
         * <div id="myTemplate">
         *    <div data-dyn-content="replace: '.all'" /> <!-- Would replace <div data-dyn-content="replace: '.all'" /> with
         *    <div data-dyn-content="replace: $content" />
         * </div>
         */
        function replace(target, bindingValue, content) {
            // TODO TFS:3745038 Dead. Needs test and testability cleanup
            var firstTime = true;
            var lastReplacement;
            var contentChanged = function (options) {
                var resolvedContent = options.content;
                // Trigger a custom event so any custom layouts can prepare for the replacement.
                target.trigger("contentHandlersReplaceStarted");
                if (resolvedContent.length > 0) {
                    // Manipulating the container of the active element in the DOM can cause the active element to lose focus
                    // and focus will usually move to the body. Save the focused element before the manipulation and restore it
                    // after to ensure the content handler doesn't remove focus.
                    var $content = $(resolvedContent);
                    var activeElement = $dyn.ui.removeFocus($content);
                    var oldValue = $dyn.shell.bodyFocusCorrection;
                    if (activeElement) {
                        $dyn.shell.bodyFocusCorrection = false;
                    }
                    var replacement_1;
                    if (options.tagName) {
                        replacement_1 = $();
                        $content.each(function (index, item) {
                            $(item).detach();
                            var element = document.createElement(options.tagName);
                            $dyn.util.mergeAttributes(item, element);
                            $(element).append($(item).children().clone(true));
                            replacement_1 = replacement_1.add(element);
                        });
                    }
                    else if (options.clone) {
                        replacement_1 = $content.clone();
                    }
                    else {
                        replacement_1 = $content;
                    }
                    if (firstTime) {
                        target.hide().after(replacement_1);
                        firstTime = false;
                    }
                    else {
                        if (lastReplacement) {
                            $(lastReplacement).detach();
                        }
                        target.after(replacement_1);
                    }
                    // Clone the replacement array (or array-like object)
                    lastReplacement = replacement_1.slice(0);
                    if (options.mutator instanceof Function) {
                        // The binding can defined a "mutator" function for dynamically customizing each wrapper per index, etc.
                        replacement_1.each(function (index, element) {
                            options.mutator(element, index, replacement_1);
                        });
                    }
                    if (activeElement) {
                        $dyn.ui.restoreFocus(activeElement);
                        $dyn.shell.bodyFocusCorrection = oldValue;
                    }
                }
                else {
                    if (lastReplacement) {
                        $(lastReplacement).detach();
                    }
                    lastReplacement = null;
                }
                // Trigger a custom event so any custom layouts can run after the replacement.
                target.trigger("contentHandlersReplaceFinished");
            };
            $dyn.util.observeContent(function () {
                return $dyn.getContentOptions(bindingValue, content);
            }, target, contentChanged);
            target[0].setAttribute("data-dyn-content-applied", "true");
            if ($dyn.debug.general) {
                target[0].dynContent.__name = "replaceContent-" + bindingValue;
            }
        }
        contentHandlers.replace = replace;
        function append(target, bindingValue, content, skipFirstTime) {
            var firstTime = skipFirstTime;
            var contentChanged = function (options) {
                if (firstTime) {
                    firstTime = false;
                    return;
                }
                var resolvedContent = options.content;
                var i;
                var newItem;
                // Manipulating the container of the active element in the DOM can cause the active element to lose focus
                // and focus will usually move to the body. Save the focused element before the manipulation and restore it
                // after to ensure the content handler doesn't remove focus.
                var activeElement = $dyn.ui.removeFocus(target);
                var oldValue = $dyn.shell.bodyFocusCorrection;
                if (activeElement) {
                    $dyn.shell.bodyFocusCorrection = false;
                }
                var $content = $(resolvedContent);
                var replacement;
                if (options.tagName) {
                    replacement = $();
                    $content.each(function (index, item) {
                        $(item).detach();
                        var element = document.createElement(options.tagName);
                        $dyn.util.mergeAttributes(item, element);
                        $(element).append($(item).children().clone(true));
                        replacement = replacement.add(element);
                    });
                }
                else if (options.clone) {
                    replacement = $content.clone();
                }
                else {
                    replacement = $content;
                }
                // Remove any changes arrange has made before editing the children
                $dyn.layout.removeArrange(target[0], true);
                // Detach and later append the tabbing container divs, the tabbing container mutation observer will re-order them
                var focusDivs = target.children(".firstFocusable, .lastFocusable").detach();
                var current = target[0].children;
                var newCount = replacement.length;
                var currentCount = current.length;
                var minCount = Math.min(newCount, currentCount);
                for (i = 0; i < minCount; i++) {
                    newItem = replacement[i];
                    var oldItem = current[i];
                    // We have been removing elements from the target element's children and have stepped past the end
                    if (!oldItem) {
                        break;
                    }
                    if (newItem !== oldItem) {
                        if (oldItem.nextSibling) {
                            target[0].insertBefore(newItem, oldItem.nextSibling);
                        }
                        else {
                            target[0].appendChild(newItem);
                        }
                        if (oldItem.parentNode) {
                            oldItem.parentNode.removeChild(oldItem);
                        }
                    }
                }
                currentCount = current.length;
                if (newCount < currentCount) {
                    // Iterate through the portion of the array that will be cut off and delete any controls from the DOM that have not been reordered
                    var childrenToRemove = [];
                    for (i = newCount; i < currentCount; i++) {
                        var child = target[0].children[i];
                        if (child) {
                            // Store the element to be removed in a separate collection so that we can
                            // still correctly index into the target's children.
                            childrenToRemove.push(child);
                        }
                    }
                    for (i = 0; i < childrenToRemove.length; i++) {
                        childrenToRemove[i].parentNode.removeChild(childrenToRemove[i]);
                    }
                }
                currentCount = current.length;
                if (newCount > currentCount) {
                    var addedCount = newCount - currentCount;
                    var updatedValues = document.createDocumentFragment();
                    for (i = 0; i < addedCount; i++) {
                        var insertAt = currentCount + i;
                        newItem = replacement[insertAt];
                        updatedValues.appendChild(newItem);
                    }
                    target[0].appendChild(updatedValues);
                }
                if (focusDivs.length) {
                    focusDivs.appendTo(target);
                }
                if (options.mutator instanceof Function) {
                    // The "mutator" is a function for dynamically customizing each piece of content.
                    target.children().each(function (index, element) {
                        options.mutator(element, index, target.children());
                    });
                }
                if (activeElement) {
                    $dyn.ui.restoreFocus(activeElement);
                    $dyn.shell.bodyFocusCorrection = oldValue;
                }
            };
            $dyn.util.observeContent(function () {
                return $dyn.getContentOptions(bindingValue, content);
            }, target, contentChanged);
            target[0].setAttribute("data-dyn-content-applied", "true");
            if ($dyn.debug.general) {
                target[0].dynContent.__name = "appendContent-" + bindingValue;
            }
        }
        contentHandlers.append = append;
    })(contentHandlers = $dyn.contentHandlers || ($dyn.contentHandlers = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=ContentHandlers.js.map
